module.exports = __webpack_public_path__ + "static/src/content/display/display.90c0661.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/display/display.png
// module id = zp15
// module chunks = 1